import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Text } from '@dixa/lib-shared-habla';
import styles from './connectorTooltip.module.scss';
export function TooltipContent({ isDependant, needs }) {
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx(Text.Paragraph, { children: isDependant
                    ? 'You can’t detach this action, as it relies on the following dependencies:'
                    : 'You can’t detach this action, as one or more actions beneath rely on the following dependencies:' }), _jsx("div", Object.assign({ className: styles.badges }, { children: needs.map((need) => (_jsx(Badge, Object.assign({ variant: "primary", size: "medium" }, { children: need }), need))) }))] })));
}
